
<div class="isg-userlist-wrapper"
     [style.height.px]="heightControl()">

  <div *ngIf="showToolbar()" class="isg-userlist-toolbar">

    <div>
      <kendo-textbox class="isg-userlist-filterusers"
                     placeholder=" Filter users..."
                     [clearButton]="true"
                     (valueChange)="onFilterChange($event)">
        <ng-template kendoTextBoxSuffixTemplate>
          <kendo-svg-icon [icon]="searchIcon"></kendo-svg-icon>
        </ng-template>
      </kendo-textbox>
    </div>

    <isg-click-filter [ngClass]="{'isg-nodisplay': !showLicenseFilter()}"
                      class="isg-userlist-filterlicensed"
                      [nullable]="false"
                      [textTrue]="'Show Licensed Users Only'"
                      [textFalse]="'Show Active Users'"
                      [(ngModel)]="showLicenseUsersOnly">
    </isg-click-filter>

  </div>

  <div class="isg-userlist-lb-wrapper">
    <kendo-listview width="100%"
                    [data]="dataItems"
                    [style.height.px]="heightListView()"
                    (change)="onChangeListView($event)"
                    (click)="onClickListView($event)">
      <ng-template kendoListViewItemTemplate let-dataItem let-index>

        <div *ngIf="(showCheckbox() === true)"
             [ngClass]="{ 'isg-lv-item-selected': dataItem.id == selectedItem?.id, 'isg-lv-chk': showCheckbox(), 'isg-lv': !showCheckbox(), 'isg-lv-item' : (true)}">

          <input type="checkbox"
                 [indeterminate]="false"
                 [(ngModel)]="dataItem.checked"
                 (change)="onCheckChange(dataItem)"
                 kendoCheckBox />

          <span (click)="onClickItemEvent(index, dataItem, $event)">{{ dataItem.displayName }}</span>

          <i *ngIf="showLicensedIcon() && assignedTolicenseId() && !showLicenseUsersOnly && dataItem.assigned" class="fa-solid fa-thumbs-up"></i>

        </div>

        <div *ngIf="!showCheckbox()"
             [ngClass]="{ 'isg-lv-item-selected': dataItem.id == selectedItem?.id, 'isg-lv-chk': showCheckbox(), 'isg-lv': !showCheckbox(), 'isg-lv-item' : (true)}"
             (click)="onClickItemEvent(index, dataItem, $event)">

          <span>{{ dataItem.displayName }}</span>

          <i *ngIf="showLicensedIcon() && assignedTolicenseId() && !showLicenseUsersOnly && dataItem.assigned" class="fa-solid fa-thumbs-up"></i>

        </div>

      </ng-template>
    </kendo-listview>
  </div>

  <isg-loader *ngIf="loadingPanelVisible()">
  </isg-loader>

</div>
